import { BaseAsyncValue } from '../../../../shared/models/async-value';
import { Observable, combineLatest, of } from 'rxjs';
import * as moment from 'moment';
import { SpecFieldNames } from '../constants/specification-field-names.enum';
import { startWith, switchMap } from 'rxjs/operators';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

/**
 * Provides a min day considering the moment hour
 */
export class MInDayProvider extends BaseAsyncValue<Date> {
  getValue(): Observable<Date> {
    if (moment().format('HH:mm:ss') >= '23:00:00') {
      return of(
        moment()
          .add(1, 'day')
          .toDate(),
      );
    } else {
      return of(moment().toDate());
    }
  }
}

export class MinMinuteProvider extends BaseAsyncValue<moment.Moment> {
  getValue(): Observable<moment.Moment> {
    const date = this.form.get(SpecFieldNames.DATE).value;
    if (moment() === date) {
      return of(moment().add(10, 'minutes'));
    } else {
      return of(null);
    }
  }
}

export class MinMinuteProviderForm extends BaseAsyncValue<moment.Moment> {
  getValue(): Observable<moment.Moment | null> {
    return combineLatest([
        this.form.get(SpecFieldNames.DATE).valueChanges.pipe(startWith(moment())),
        this.form.get(SpecFieldNames.TIME).valueChanges.pipe(startWith(moment()))]).pipe(
      switchMap(([date, time]) => {
        const auxDate = _safe(() => this.form.get(SpecFieldNames.DATE).value, date);
        if (moment().isSame(auxDate, 'day')) {
          return of(moment().toDate());
        } else {
          return of(null);
        }
      }),
    );
  }
}
